import { all } from "redux-saga/effects";
import { hydrateSearchReferralSaga } from "./ducks/referralSearch";
import {
  createSentReferralSaga,
  getSentReferralSaga,
} from "./ducks/referralsSent";
import { getReceivedReferralSaga } from "./ducks/referralsReceived";
import { fetchReferralStatesSaga, fetchReferToStatesSaga } from "./ducks/board";
import {
  determineAuthStateSaga,
  signInSaga,
  signOutSaga,
  checkAuthStateSaga,
} from "./ducks/auth";
import { hydratePatientSaga } from "./ducks/patients";
import {
  handleUpdateDocumentMetaSaga,
  openSplitDialogSaga,
} from "./ducks/docserver";
import { getSchedulingProviderStaffSaga } from "./ducks/staff";
import { checkAppVersionSaga } from "./ducks/version";
import { sendFaxDocumentSaga } from "./ducks/fax";
import { getApiHostSaga } from "./ducks/api";
import {
  verifyTotpSaga,
  deleteTotpSaga,
  getTotpConfigSaga,
  getTotpSecretSaga,
} from "./ducks/totp";

export default function* rootSaga() {
  yield all([
    createSentReferralSaga(),
    determineAuthStateSaga(),
    fetchReferralStatesSaga(),
    fetchReferToStatesSaga(),
    getReceivedReferralSaga(),
    getSentReferralSaga(),
    signInSaga(),
    signOutSaga(),
    checkAuthStateSaga(),
    checkAppVersionSaga(),
    openSplitDialogSaga(),
    handleUpdateDocumentMetaSaga(),
    getApiHostSaga(),
    hydratePatientSaga(),
    sendFaxDocumentSaga(),
    getSchedulingProviderStaffSaga(),
    getTotpConfigSaga(),
    getTotpSecretSaga(),
    verifyTotpSaga(),
    deleteTotpSaga(),
    hydrateSearchReferralSaga(),
  ]);
}
